import { useDataSubmit, useDataValue } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'
import { FEE_MODE_RANGES, FEE_MODE } from 'Data/constants.js'
import { notifyError, useNotifications } from 'Logic/Notifications.js'
import { percentage } from 'Data/format.js'

export function useOnClick(props) {
  let [, notify] = useNotifications()
  let submit = useDataSubmit({
    context: 'provider_accounts',
    viewPath: props.viewPath,
  })
  let provider_account = useDataValue({
    context: 'provider_account',
    viewPath: props.viewPath,
  })
  let setFlowTo = useSetFlowTo(props.viewPath)

  return function onClick() {
    switch (provider_account.fee_mode) {
      case FEE_MODE.PLATFORM_FEE: {
        if (
          typeof provider_account.card_fee_percent !== 'number' ||
          provider_account.card_fee_percent <
            FEE_MODE_RANGES.PLATFORM_FEE.CARD.MIN ||
          provider_account.card_fee_percent >
            FEE_MODE_RANGES.PLATFORM_FEE.CARD.MAX
        ) {
          notify(
            notifyError(
              `The card platform fee must be a value between ${percentage(
                FEE_MODE_RANGES.PLATFORM_FEE.CARD.MIN
              )} and ${percentage(FEE_MODE_RANGES.PLATFORM_FEE.CARD.MAX)}.`
            )
          )
          return
        }
        if (
          typeof provider_account.ach_fee_percent !== 'number' ||
          provider_account.ach_fee_percent <
            FEE_MODE_RANGES.PLATFORM_FEE.ACH.MIN ||
          provider_account.ach_fee_percent >
            FEE_MODE_RANGES.PLATFORM_FEE.ACH.MAX
        ) {
          notify(
            notifyError(
              `The ACH platform fee must be a value between ${percentage(
                FEE_MODE_RANGES.PLATFORM_FEE.ACH.MIN
              )} and ${percentage(FEE_MODE_RANGES.PLATFORM_FEE.ACH.MAX)}.`
            )
          )
          return
        }
        break
      }
      case FEE_MODE.SURCHARGE: {
        if (
          typeof provider_account.card_fee_percent !== 'number' ||
          provider_account.card_fee_percent <
            FEE_MODE_RANGES.SURCHARGE.CARD.MIN ||
          provider_account.card_fee_percent > FEE_MODE_RANGES.SURCHARGE.CARD.MAX
        ) {
          notify(
            notifyError(
              `The surcharge must be a value between ${percentage(
                FEE_MODE_RANGES.SURCHARGE.CARD.MIN
              )} and ${percentage(FEE_MODE_RANGES.SURCHARGE.CARD.MAX)}.`
            )
          )
          return
        }
        break
      }
      case FEE_MODE.STANDARD:
      default:
        break
    }

    if (
      [FEE_MODE.PLATFORM_FEE, FEE_MODE.SURCHARGE].includes(
        provider_account.fee_mode
      ) &&
      !provider_account.fee_acknowledged_by_user_id
    ) {
      setFlowTo(
        normalizePath(props.viewPath, '../../../AcknowledgePlatformFee/Content')
      )
    } else {
      submit({
        type: 'save_settings',
        account_id: provider_account.account_id,
        is_pay_app_enabled: provider_account.greyfinch_pay_app_enabled,
        fee_mode: provider_account.fee_mode,
        card_fee_percent: provider_account.card_fee_percent,
        ach_fee_percent: provider_account.ach_fee_percent,
        fee_acknowledged_by_user_id:
          provider_account.fee_acknowledged_by_user_id,
      })
    }
  }
}
